import { baseApi } from '@/lib/api/baseApi';

import type { CargoLocation } from '@/types/cargo';

// İl/ilçe/semt listeleri pratikte değişmiyor. Kullanıcı akışta ileri-geri
// gezinirken aynı listelerin tekrar tekrar çekilmemesi için cache uzun tutulur.
const REFERENCE_CACHE_SECONDS = 60 * 60;

export const cargoApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Adres seçici cascade'inin ilk adımı (81 il).
    getCargoCities: builder.query<CargoLocation[], void>({
      query: () => 'repair-request/public/cargo/cities',
      keepUnusedDataFor: REFERENCE_CACHE_SECONDS,
    }),

    // İl seçilmeden çağrılmaz; çağıran taraf `skipToken` ile bekletir.
    getCargoTowns: builder.query<CargoLocation[], number>({
      query: (cityId) => `repair-request/public/cargo/cities/${cityId}/towns`,
      keepUnusedDataFor: REFERENCE_CACHE_SECONDS,
    }),

    getCargoDistricts: builder.query<CargoLocation[], number>({
      query: (townId) => `repair-request/public/cargo/towns/${townId}/districts`,
      keepUnusedDataFor: REFERENCE_CACHE_SECONDS,
    }),

    // Randevu günleri il/ilçe ADI ile sorgulanır (id ile değil).
    //
    // `from`/`to` opsiyonel; verilmezse backend BUGÜN–+14 gün aralığını sorar.
    // Talep tarafındaki doğrulama ise bugünü kabul etmiyor (Hepsijet aynı gün
    // alım yapmıyor), o yüzden aralığı çağıran taraf yarından başlatıyor —
    // aksi halde takvimde çıkan bugün seçilince talep 400 dönerdi.
    //
    // Kota ilçe bazında: bir ilçe dolu takvim dönerken diğeri boş liste
    // dönebilir. Sonuç güne bağlı olduğundan referans listeleri gibi uzun
    // cache'lenmez.
    getCargoPickupDates: builder.query<
      string[],
      { city: string; town: string; from: string; to: string }
    >({
      query: ({ city, town, from, to }) => ({
        url: 'repair-request/public/cargo/pickup-dates',
        params: { city, town, from, to },
      }),
    }),
  }),
});

export const {
  useGetCargoCitiesQuery,
  useGetCargoTownsQuery,
  useGetCargoDistrictsQuery,
  useGetCargoPickupDatesQuery,
} = cargoApi;
